import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { Message, Loading } from 'element-ui'
// import router from '@/router/index.js'
// import { getHomePage} from '@/utils/auth'
// var BASE_URL;
// if(process.env.NODE_ENV === 'development'){
//   BASE_URL="/"
// }else{
//   BASE_URL= getHomePage() 
// }

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
 
})
let loading
// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Content-Type']='application/json;charset=UTF-8'
    // do something before request is sent
    loading = Loading.service({
      lock: true,
      text: 'loading...',
      spinner: 'el-icon-loading',
      background: 'transparent',
      customClass: 'loading-mask'
    })
    

    if (getToken()) {
      // let each request carry token
      // please modify it according to the actual situation
      config.headers['uc-token'] = getToken()
     
      // config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    loading.close()
    const res = response.data
    // if the custom code is not 1000, it is judged as an error.
    if (res.code == 500 || res.code==10004) {
      Message.error(res.msg || 'Error');
      if (res.code == '401') {
        setTimeout(() => {
          store.dispatch('user/resetToken').then(() => {
            window.location.reload()
          })
        }, 2000);
      }
      // if(res.msg=='区域id不能为空'){
      
      //   router.push("/login")
      // }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    loading.close()
    Message.error(error.msg || error);
    return Promise.reject(error)
  }
)

export default service
